import { isEmpty, isObject } from 'lodash'
import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import CompareProduct from '@theme/components/product/CompareProduct'
import LayoutBase from '@theme/components/shop/LayoutBase'
import Loader from '@theme/components/utils/Loader'
import LoadingMixin from '~/mixins/LoadingMixin'
import SeoMixin from '~/mixins/SeoMixin'
import UtilityGridMixin from '~/mixins/UtilityGridMixin'

export default {
  components: {
    AppTitle,
    Breadcrumbs,
    CompareProduct,
    LayoutBase,
    Loader,
  },
  mixins: [LoadingMixin, SeoMixin, UtilityGridMixin],
  head() {
    return this.getSeoHead({ yamlKey: 'PageCompare', noindex: true, nofollow: false })
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageCompare.breadcrumbs.index'),
          path: this.localePath({ name: 'compare' }),
        },
      ],
      columnClass: [],
      products: [],
      visibleCount: {
        xs: 2,
        sm: 3,
      },
    }
  },
  beforeMount() {
    const query = this.$route.query

    if (isObject(query) && 'products' in query) {
      const productIds = query.products.split(',')

      if (!isEmpty(productIds)) {
        this.$store.commit('compare/SET_PRODUCTS', { products: productIds })
      }
    }

    const path = this.localePath({
      name: 'compare',
      query: { products: this.productIds.join(',') },
    })
    history.replaceState({}, document.title, path)
  },
  mounted() {
    this.columnClass.push(this.computeColumnClass(this.visibleCount))
    this.fetchProducts()
  },
  methods: {
    async fetchProducts() {
      this.startLoading()
      this.products = await this.$store.dispatch('product/LOAD_PRODUCTS', { ids: this.productIds })
      const promises = this.products.map(product => this.$store.dispatch('product/FETCH_PARAMETERS', { product }))
      await Promise.all(promises)
      this.stopLoading()
    },
  },
  computed: {
    productIds() {
      return this.$store.getters['compare/productIds']
    },
    hintClass() {
      const result = []

      Object.keys(this.visibleCount).forEach(breakpoint => {
        if (this.products.length <= this.visibleCount[breakpoint]) {
          result.push(breakpoint === 'xs' ? 'd-none' : `d-${breakpoint}-none`)
        } else {
          result.push(breakpoint === 'xs' ? 'd-block' : `d-${breakpoint}-block`)
        }
      })

      return result
    },
    parameters() {
      const parameters = {}

      // Find parameters
      this.products.forEach((product, productIndex) => {
        if (product.content.parameters && product.content.parameters.length > 0) {
          product.content.parameters.forEach(parameter => {
            if (parameter.entity) {
              if (!parameters[parameter.entity._id]) {
                // Init parameter row
                parameters[parameter.entity._id] = {
                  id: parameter.entity._id,
                  title: parameter.entity.title,
                  productValues: new Array(this.products.length),
                }
              }

              // Add product value
              if (parameter.values > 0) {
                parameters[parameter.entity._id].productValues[productIndex] = parameter.values
              } else {
                parameters[parameter.entity._id].productValues[productIndex] = parameter.valueEntities
                  .map(value => {
                    return value.title
                  })
                  .join(', ')
              }
            }
          })
        }
      })

      return Object.values(parameters)
    },
  },
  watch: {
    productIds: function() {
      this.fetchProducts()
    },
  },
}
